import React from "react";

/**
 * Se encarga de construir un modal dialog que permite desplegar
 * mensajes.
 */
export default class Modal extends React.Component {
  /**
   * Almacena del estado del componente
   */
  state = {};
  /**
   * Cuando se renderiza el componete se setea la referencia al
   * componente.
   */
  componentDidMount() {
    this.props.onRef(this);
  }

  /**
   * Se encarga de mostrar el dialgo.
   */
  open = () => {
    this.setState({
      open: true
    });
  };

  /**
   * Se encarga de manejar el close del dialog.
   */
  close = evt => {
    if (evt) {
      evt.stopPropagation();
    }
    this.setState({ open: false });
  };

  /**
   * Se encarga de renderizar el componente.
   */
  render() {
    const { open } = this.state;
    const isOpen = open ? "is-active" : "";
    return (
      <div className={`modal ${isOpen}`}>
        <div className="modal-background" />
        <div className="modal-card">
          <header className="modal-card-head">
            <p className="modal-card-title">{this.props.title}</p>
            <a
              onClick={evt => this.close(evt)}
              className="delete"
              aria-label="close"
            />
          </header>
          {this.props.children}
        </div>
      </div>
    );
  }
}
